<template>
  <div id="app" ref="app">
    <el-container>

      <el-header>
        <div class="logo">
          <!-- <img src="./assets/img/toplogo.png" alt /> -->
          <img src="./assets/img/yzlogo.png" alt />
          <h1>影智科技</h1>
        </div>
        <el-menu
          :default-active="defaultActive"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          :router="router"
        >
          <el-menu-item index="/home">首页</el-menu-item>
          <!--
          <el-menu-item index="/news">新闻资讯</el-menu-item>
          <el-menu-item index="/product">产品中心</el-menu-item>
          <el-menu-item index="/case">经典案例</el-menu-item>
          <el-menu-item index="/goin">走进科建</el-menu-item>
          <el-menu-item index="/download">下载APP</el-menu-item>
          -->
        </el-menu>
      </el-header>

      <el-main>
        <router-view />
      </el-main>

      <div class="footer" v-show=true >
        <div class="footer-content">
          <ul class="content-nav">
            <li>
              <p>影智科技</p>
              <span>发展历程</span>
              <span>企业文化</span>
              <span>资质荣誉</span>
              <span>合作伙伴</span>
            </li>
            <li>
              <p>新闻资讯</p>
              <span>公司新闻</span>
              <span>行业动态</span>
            </li>
            <li>
              <p>产品中心</p>
              <span>影智多开</span>
              <span>AI写作快译猫</span>
              <span>AI智能抠图</span>
            </li>
            <li>
              <p>联系我们</p>
              <span>邮箱：zhyzkj2023@163.com</span>
              <span>地址：珠海市高新区唐家湾镇情侣北路3888号501-07-033</span>
            </li>
          </ul>
          <img src="./assets/img/qrcode_for_yz.jpg" alt />
        </div>
        <div class="divide-line"></div>
        <div class="copyright">
          <p class="copyright-company">CopyRight © 2024 珠海影智科技有限公司</p>
          <a class="copyright-icp" href="https://beian.miit.gov.cn/" target="_blank">
            <span >粤ICP备2023124085号-1</span>
          </a>
        </div>
      </div>
      
    </el-container>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  name: "App",
  data() {
    return {
      router: true,
      defaultActive: "/home",
      isShow: false
    };
  },
  mounted() {
    this.$nextTick(() => {
      const $app = this.$refs.app;
      // 设置 屏幕 百分比 尺寸 适配
      const standardScale = "100%" / "100%";

      window.addEventListener(
        "resize",
        _.debounce(function () {
          const docHeight = document.body.clientHeight;
          const docWidth = document.body.clientWidth;

          if (docWidth < 1680) {
            const currentScale = docHeight / docWidth;
            let [scale, translate] = [0, 0];
            if (currentScale < standardScale) {
              // 以高度计算
              scale = docHeight / 1080;
              const shouleWidth = 1920 * scale;
         
              const offsetWidth = docWidth - shouleWidth;
              translate =
                offsetWidth > 0 ? `translate(${offsetWidth / 2}px, 0)` : "";
            } else {
              // 以宽度计算
              scale = docWidth / 1920;
              const shouleHeight = 1080 * scale;
              const offsetHeight = docHeight - shouleHeight;
              translate =
                offsetHeight > 0 ? `translate(0, ${offsetHeight / 2}px)` : "";
            }
            window.console.log(translate);
            $app.style.cssText = `
            transform: scale(${scale}) ${translate};
            transform-origin: top left;
            min-width: 1920px;
            min-height: 1080px;
          `;
          } else {
            $app.style.cssText = "";
          }
        }),
        300
      );

      if (document.createEvent) {
        var event = document.createEvent("HTMLEvents");
        event.initEvent("resize", true, true);
        window.dispatchEvent(event);
      } else if (document.createEventObject) {
        window.fireEvent("onresize");
      }
    });
  },

  methods: {
    handleSelect(key) {
      this.isShow =this.defaultActive != key;
      window.console.log(this.isShow);
    }
  }
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
html,
body {
  height: 100%;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.el-header {
  display: flex;
  justify-content: space-between;
  align-content: center;
  width: 1240px;
  margin: 0 auto;
  //background-color: #fff;

  .logo {
    width: 280px;
    padding: 10px;
    display: flex;
    align-items: center;
    img {
      width: 32px;//100%;
      line-height: 48px;
    }
    h1 {
      padding: 10px
      
    }
  }
}
.el-main {
  padding: 0 !important;
}

.footer {
  width: 100%;
  height: auto;
  overflow: hidden;
  background-color: #1F2329;
  &-content {
    width: 1240px;
    margin: 0 auto;
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
    .content-nav {
      display: flex;
      justify-content: space-around;
      li {
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        //justify-content: center;
        align-items: flex-start;
        p {
          font-size: 20px;
          color: #d4edff;
          padding: 10px 0;
        }
        span {
          color: #f7f7f7;
          font-weight: 300;
          padding: 5px 0;
        }
      }
    }
    img {
      width: 170px;
      height: 170px;
      padding: 10px;
    }
  }
  .divide-line {
    margin-top: 20px;
    margin-bottom: 20px;
    margin-left: 2%;
    margin-right: 2%;
    background-color: #646A73;
    height: 1px;
  }
  .copyright {
    height: 70px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    &-company {
      color:#545455;
      line-height: 20px;
      margin-top: 5px;
      margin-bottom: 5px;
    }
    &-icp {
      color:#828283;
      line-height: 20px;
      margin-bottom: 10px
    }
  }
}
</style>

